import React, { useEffect, useState } from 'react';
import {
  useStyles,
  TableControl,
  SearchContainer,
  InputContainer,
} from './styles';
import {
  Icon,
  Grid,
  Typography,
  Table,
  TableBody,
  Tooltip,
  Button,
  CircularProgress,
  Paper,
  Chip,
  Box,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Layout from 'shared/component/Layout';
import { AntTab, AntTabs } from 'shared/component/TabsComponents';
import { Link } from 'react-router-dom';
import CardShiftTable from './components/shiftTable';
import CollapseTable from 'shared/component/CollapseTable';
import { useConfig } from 'hook/config';
import useScales from 'hook/scales';
import appColors from 'utils/appColors';
import StatusSwitch from 'shared/component/StatusSwitch';
import { useHistory } from 'react-router-dom';
import SearchInputDebounce from 'shared/component/forms/SearchInputDebounce';
import { ModalAlertSucess } from 'shared/component/modalAlertSucess';
import '../../shared/fixedtab.css';
import SpecialtyName from './components/specialtyName';
import usePersistedState from 'hook/usePersistedState';
import HasPermission from 'utils/checkPermission';

export default function ScalesPage() {
  const history = useHistory();
  const classes = useStyles();
  const { config } = useConfig();

  const permissions = {
    read: 'scale/r',
    create: 'scale/c',
    delete: 'scale/d',
    update: 'scale/u',
  };

  const [stateModal, setStateModal] = useState(false);

  const [filterScales, setFilterScales] = usePersistedState(
    'plantaoextra@scales',
    {
      value: 0,
      page: 1,
      per_page: 10,
      search: '',
      status: 2,
      unit_id:
        config.hospitalData.length > 0 ? config.hospitalData[0].id : null,
    }
  );

  const {
    scalesTimesFilter,
    scalesFilter,
    totalScales,
    loadingChange,
    message,
    setMessage,
    getFilterScales,
    getTimesFilterScales,
    changeScalesId,
    deleteScale,
    status,
  } = useScales();

  const weekDays = [
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado',
    'Domingo',
  ];

  const { page, unit_id, perPageScale, search } = filterScales;
  React.useEffect(() => {
    config.hospitalData.length > 0 &&
      getFilterScales(
        page,
        perPageScale,
        unit_id,
        '',
        '',
        '',
        filterScales.search,
        null
      );
  }, [page, totalScales, unit_id, search]);

  React.useEffect(() => {
    message && message !== 'Deletado com Sucesso' && setStateModal(true);
  }, [message]);

  const [seletedRow, setSelectedRow] = useState('');
  const handleStateModal = () => {
    setStateModal(!stateModal);
    setMessage('');
  };

  const handleChangePage = (page) => {
    setFilterScales({ ...filterScales, page: page });
  };

  const handleSearch = (search) => {
    typeof search === 'string'
      ? setFilterScales({ ...filterScales, page: 1, search: search })
      : false;
  };

  const handleChangeTab = (event, newValue) => {
    const unit = config.hospitalData[newValue];
    if (!unit) return;
    setFilterScales((prev) => ({
      ...prev,
      value: newValue,
      page: 1,
      search: '',
      unit_id: unit.id,
    }));
  };

  const componentMinimizable = (row) => (
    <Box className={classes.pageWrap}>
      <Paper elevation={0} className={classes.expandPaper}>
        {scalesTimesFilter.loadingScales ? (
          <div className={classes.loadingExpand}>
            <CircularProgress
              style={{
                color: appColors.PRIMARY_COLOR,
              }}
              size={48}
            />
          </div>
        ) : (
          <div
            className={
              config.open
                ? classes.container_minimizable
                : classes.container_minimizableClose
            }
          >
            <div className={classes.weekHeaderRow}>
              {weekDays.map((day) => (
                <Typography
                  key={day}
                  component="span"
                  className={classes.weekDayLabel}
                >
                  {day}
                </Typography>
              ))}
            </div>
            <Table style={{ backgroundColor: 'transparent' }}>
              <TableBody>
                <Grid>
                  <Grid component="th" scope="row">
                    {scalesTimesFilter.dataTimesScalesFilter.length > 0 ? (
                      scalesTimesFilter.dataTimesScalesFilter
                        .slice(0, 3)
                        .map((scales) => (
                          <CardShiftTable
                            key={scales.id}
                            scales={scales}
                            hourStart={scales[0].hour_start}
                            hourEnd={scales[0].hour_end}
                            seachTimesScale={seachTimesScale}
                            permissions={permissions}
                          />
                        ))
                    ) : (
                      <Button
                        className={classes.tableAddScales}
                        onClick={() => {
                          history.push(
                            `/escala-completa/${filterScales.unit_id}/${row.id}/true`
                          );
                        }}
                      >
                        <Icon className={classes.iconAdd}>
                          add_circle_outline
                        </Icon>
                        <Typography className={classes.textAddTable}>
                          Adicionar horário
                        </Typography>
                      </Button>
                    )}
                  </Grid>
                </Grid>
                <Link
                  style={{ textDecoration: 'none' }}
                  to={`/escala-completa/${filterScales.unit_id}/${row.id}`}
                >
                  <div className={classes.fullScaleLink}>
                    <Typography className={classes.fullScaleLinkText}>
                      Ver escala completa
                      <Icon fontSize="small">keyboard_arrow_right</Icon>
                    </Typography>
                  </div>
                </Link>
              </TableBody>
            </Table>
          </div>
        )}
      </Paper>
    </Box>
  );

  const onExpandRow = (row, isExpanded) => {
    if (isExpanded) seachTimesScale(row.id);
  };

  const seachTimesScale = (id) => {
    if (scalesFilter.dataScalesFilter.length > 0) {
      getTimesFilterScales(filterScales.unit_id, id);
    }
  };

  const abas = config.hospitalData.map((item) => ({
    name: item.name,
    id: item.id,
  }));
  const columns = ({ handleChangeStatus }) => {
    return [
      { id: 'id', label: '#', minWidth: 10, align: 'center' },
      { id: 'name', label: 'Escala', minWidth: 100 },
      {
        id: 'specialty.name',
        label: 'Especialidade',
        minWidth: 5,
        render: (rowData) => <SpecialtyName rowData={rowData} />,
      },
      {
        id: 'has_schedule',
        label: 'Possui escala',
        minWidth: 100,
        align: 'center',
        render: (rowData) => (
          <Box display="flex" justifyContent="center" width="100%">
            <Chip
              size="small"
              label={rowData?.has_schedule === true ? 'Sim' : 'Não'}
              className={classes.scheduleChip}
              color={rowData?.has_schedule === true ? 'primary' : 'default'}
              variant={rowData?.has_schedule === true ? 'default' : 'outlined'}
            />
          </Box>
        ),
      },
      {
        id: 'status',
        label: 'Status da escala',
        minWidth: 10,
        align: 'center',
        render: (rowData, index) => (
          <StatusSwitch
            key={index}
            changeStatus={handleChangeStatus}
            rowData={rowData}
            permissions={permissions}
          />
        ),
      },
    ];
  };

  const handleChangeStatus = (status, rowData) => {
    changeScalesId(rowData.id, rowData.unit.id).then(() => {
      getFilterScales(
        page,
        perPageScale,
        unit_id,
        '',
        '',
        '',
        filterScales.search,
        null
      );
    });
  };

  useEffect(() => {
    if (config.hospitalData.length <= 2) {
      setFilterScales({
        value: 0,
        page: 1,
        per_page: 10,
        search: '',
        unit_id:
          config.hospitalData.length > 0 ? config.hospitalData[0].id : null,
      });
    }
  }, [config]);
  useEffect(() => {
    if (scalesFilter.dataScalesFilter.length < 1) {
      setFilterScales({ ...filterScales, page: 1 });
    }
  }, []);

  return (
    <Layout
      route="/cadastros"
      specificRoute
      title="Escalas"
      showToday
      backArrow
      isLoading={loadingChange}
    >
      <Box className={classes.pageWrap}>
        <Paper elevation={0} className={classes.headerCard}>
          <Typography className={classes.pageSubtitle}>
            Gerencie escalas e horários por unidade. Expanda uma linha para ver
            um resumo da semana ou abra a escala completa.
          </Typography>
          <div id="fixed-tab" className={classes.tabsRow}>
            <AntTabs
              onChange={handleChangeTab}
              value={filterScales.value}
              aria-label="Unidades"
            >
              {abas.map((option, i) => (
                <AntTab key={option.id ?? i} label={option.name} />
              ))}
            </AntTabs>
          </div>
          <SearchContainer className={classes.filtersRow}>
            <InputContainer className={classes.searchFieldWrap}>
              <SearchInputDebounce
                className={classes.inputWidth}
                onChange={handleSearch}
                value={filterScales.search}
                placeholder="Buscar por nome da escala"
                style={{
                  alignItems: 'center',
                  height: 48,
                  width: '100%',
                }}
              />
            </InputContainer>
            <Tooltip
              title={
                HasPermission(permissions.create)
                  ? ''
                  : 'Você não tem permissão'
              }
              placement="bottom"
              arrow
            >
              <Button
                data-cy="btn_cadastrar"
                startIcon={<AddIcon />}
                onClick={
                  HasPermission(permissions.create)
                    ? () =>
                        history.push(
                          `/cadastros/escalas/cadastrar/${filterScales.unit_id}`
                        )
                    : undefined
                }
                className={classes.registerButton}
              >
                Cadastrar escala
              </Button>
            </Tooltip>
          </SearchContainer>
        </Paper>
      </Box>
      <TableControl data-cy="dataTable">
        <CollapseTable
          permissions={permissions}
          pageByProps={filterScales.page}
          dataList={scalesFilter.dataScalesFilter}
          useTimeOut={false}
          columns={columns({ handleChangeStatus })}
          loading={scalesFilter.loadingScales}
          totalList={scalesFilter.totalScales}
          redirectTo={`/escala-completa/${filterScales.unit_id}`}
          perPage={filterScales?.perPage}
          origin="SCALE"
          handleChangePage={handleChangePage}
          componentMinimizable={componentMinimizable}
          onExpandRow={onExpandRow}
          seletedRow={seletedRow}
          setSelectedRow={setSelectedRow}
          onDeleteRequest={(scale_id) => {
            scalesFilter.dataScalesFilter.length > 1
              ? deleteScale(unit_id, scale_id).then(() => {
                  getFilterScales(page, perPageScale, unit_id);
                })
              : deleteScale(unit_id, scale_id).then(() => {
                  getFilterScales(page === 1, perPageScale, unit_id);
                });
          }}
        />
      </TableControl>
      {status?.status !== 403 ? (
        <ModalAlertSucess
          openSendFinish={stateModal}
          handleCloseSendFinish={handleStateModal}
          messageTitleAlert={message}
          error
        />
      ) : (
        <ModalAlertSucess
          openSendFinish={stateModal}
          handleCloseSendFinish={handleStateModal}
          messageTitleAlert={message}
        />
      )}
    </Layout>
  );
}
